export default __webpack_public_path__ + "static/G4Slogo-f951062ce0a292dee60cb5e5b5f03742.png";